module.exports = __webpack_public_path__ + "img/WindImGesicht.0972976b.svg";